export default __webpack_public_path__ + "static/media/elevate-gry-1.ecddebe1.png";